import { defineMessages, type IntlShape, type MessageDescriptor } from 'react-intl';

export const filterMessages = defineMessages({
  searchForLocation: {
    defaultMessage: 'Search for a location',
    id: 'Tr8VrF6b0M',
    description: 'Search placeholder in the location filter combobox',
  },
  noLocationFound: {
    defaultMessage: 'No location found.',
    id: 'TJDRxP14Q6',
    description: 'Empty state when location filter search returns no matches',
  },
  searchForSpecialty: {
    defaultMessage: 'Search for a specialty',
    id: 'ekrpMVt6Fv',
    description: 'Search placeholder in the specialty filter combobox',
  },
  noSpecialtyFound: {
    defaultMessage: 'No specialty found.',
    id: 'NWHmMN8bD2',
    description: 'Empty state when specialty filter search returns no matches',
  },
  selectLocation: {
    defaultMessage: 'Select a location...',
    id: '075FZgkeum',
    description: 'Placeholder when no location is selected in the filter',
  },
  selectSpecialty: {
    defaultMessage: 'Select a specialty...',
    id: 'WU6MbSBsCB',
    description: 'Placeholder when no specialty is selected in the filter',
  },
  selectSort: {
    defaultMessage: 'Select a sort...',
    id: 'RDXcN8xjFD',
    description: 'Placeholder when no sort option is selected in the filter',
  },
  selectCategory: {
    defaultMessage: 'Select a category...',
    id: '4I7BZUOE9h',
    description: 'Placeholder when no category is selected in the filter',
  },
  searchForFilter: {
    defaultMessage: 'Search...',
    id: 'ss4K1oRPQx',
    description:
      'Generic search placeholder for filter comboboxes with unknown filter type',
  },
  noFilterResultsFound: {
    defaultMessage: 'No results found',
    id: 'hX5PAbCTOR',
  },
  selectFilter: {
    defaultMessage: 'Select...',
    id: 'rNljM1pa10',
    description: 'Generic placeholder when no value is selected in an unknown filter',
  },
});

const FILTER_SEARCH_PLACEHOLDER_MESSAGES: Record<string, MessageDescriptor> = {
  location: filterMessages.searchForLocation,
  specialty: filterMessages.searchForSpecialty,
};

const FILTER_EMPTY_MESSAGES: Record<string, MessageDescriptor> = {
  location: filterMessages.noLocationFound,
  specialty: filterMessages.noSpecialtyFound,
};

const FILTER_SELECT_PLACEHOLDER_MESSAGES: Record<string, MessageDescriptor> = {
  location: filterMessages.selectLocation,
  specialty: filterMessages.selectSpecialty,
  sort: filterMessages.selectSort,
  category: filterMessages.selectCategory,
};

export function getFilterSearchPlaceholder(intl: IntlShape, name: string): string {
  const message = FILTER_SEARCH_PLACEHOLDER_MESSAGES[name];
  return intl.formatMessage(message ?? filterMessages.searchForFilter);
}

export function getFilterEmptyMessage(intl: IntlShape, name: string): string {
  const message = FILTER_EMPTY_MESSAGES[name];
  return intl.formatMessage(message ?? filterMessages.noFilterResultsFound);
}

export function getFilterSelectPlaceholder(intl: IntlShape, name: string): string {
  const message = FILTER_SELECT_PLACEHOLDER_MESSAGES[name];
  return intl.formatMessage(message ?? filterMessages.selectFilter);
}
